import { booleanAttribute, Component, EventEmitter, Input, Output } from '@angular/core';
import { ActionButton } from './action-button';
import { Filters } from '../va-filter/filters/filter';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatFormField } from '@angular/material/input';
import { NgClass } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'uikit-mobile-action-bar',
  styleUrls: ['./mobile-action-bar.component.scss'],
  template: `
    @if (isSearchable || primaryActionButton || secondaryActionButton || showInfoIcon || sidebarFilters) {
      <div class="mobile-action-bar">
        <div>
          @if (isSearchable) {
            <mat-form-field
              [floatLabel]="'auto'"
              class="mat-form-field mat-form-field-mobile"
              [ngClass]="{ 'active-search': searchActive }"
            >
              <input
                matInput
                #search
                placeholder="{{ 'COMMON.ACTION_LABELS.SEARCH' | translate }}"
                (keyup)="updateSearchValue(search.value)"
                [value]="searchValue"
              />
              <mat-icon matPrefix>search</mat-icon>
              @if (search.value) {
                <button
                  mat-button
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  (click)="search.value = ''; updateSearchValue('')"
                >
                  <mat-icon class="close">close</mat-icon>
                </button>
              }
            </mat-form-field>
          }
          @if (primaryActionButton) {
            @if (primaryActionButton.link) {
              <a mat-icon-button [href]="primaryActionButton.link" [target]="primaryActionButton.target ?? '_self'">
                @if (primaryActionButton.icon) {
                  <mat-icon>{{ primaryActionButton.icon }}</mat-icon>
                }
                @if (primaryActionButton.svgIcon) {
                  <mat-icon [svgIcon]="primaryActionButton.svgIcon" />
                }
              </a>
            }
            @if (!primaryActionButton.link && primaryActionButton.handler) {
              <button mat-icon-button (click)="primaryActionButton.handler()">
                @if (primaryActionButton.icon) {
                  <mat-icon>{{ primaryActionButton.icon }}</mat-icon>
                }
                @if (primaryActionButton.svgIcon) {
                  <mat-icon [svgIcon]="primaryActionButton.svgIcon" />
                }
              </button>
            }
          }
          @if (secondaryActionButton) {
            @if (secondaryActionButton.link) {
              <a mat-icon-button [href]="secondaryActionButton.link">
                @if (secondaryActionButton.icon) {
                  <mat-icon>{{ secondaryActionButton.icon }}</mat-icon>
                }
                @if (secondaryActionButton.svgIcon) {
                  <mat-icon [svgIcon]="secondaryActionButton.svgIcon" />
                }
              </a>
            }
            @if (!secondaryActionButton.link && secondaryActionButton.handler) {
              <button mat-icon-button (click)="secondaryActionButton.handler()">
                @if (secondaryActionButton.icon) {
                  <mat-icon>{{ secondaryActionButton.icon }}</mat-icon>
                }
                @if (secondaryActionButton.svgIcon) {
                  <mat-icon [svgIcon]="secondaryActionButton.svgIcon" />
                }
              </button>
            }
          }
          @if (showInfoIcon) {
            <button mat-icon-button (click)="showInfo()">
              <mat-icon>help_outline</mat-icon>
            </button>
          }
          @if (sidebarFilters) {
            <button mat-icon-button (click)="toggleSidebar()">
              <mat-icon>filter_list</mat-icon>
            </button>
          }
        </div>
      </div>
    }
  `,
  standalone: true,
  imports: [MatIconButton, MatIcon, MatFormField, NgClass, TranslateModule],
})
export class MobileActionBarComponent {
  @Input({ transform: booleanAttribute }) isSearchable!: boolean;
  @Input() searchValue!: string;
  @Input() searchActive!: boolean;
  @Input() primaryActionButton!: ActionButton | null;
  @Input() secondaryActionButton!: ActionButton | null;
  @Input({ transform: booleanAttribute }) showInfoIcon!: boolean;
  @Input() sidebarFilters!: Filters | null;

  @Output() updateSearch = new EventEmitter<string>();
  @Output() infoIconClick = new EventEmitter<void>();
  @Output() toggleSidebarClick = new EventEmitter<void>();

  showInfo(): void {
    this.infoIconClick.emit();
  }

  toggleSidebar(): void {
    this.toggleSidebarClick.emit();
  }

  updateSearchValue(value: string): void {
    this.updateSearch.emit(value);
  }
}
